import React, {useEffect, useState} from "react";
import {Badge, Row} from "antd";
import {UploadOutlined, DownloadOutlined, BellOutlined} from "@ant-design/icons";
import moment from "moment";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../hooks/useStore";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import {ExcelButtonsContainer} from "../ShiftSuggestionStyles";
import {ExcelButtonsPropTypes} from "./ShiftSuggestionComponentPropTypes";
import ShiftForecastUploadModal from "./ShiftForecastUploadModal/ShiftForecastUploadModal";
import SendNotification from "./SendNotificationModal/SendNotification";
import PreferenceNotificationModal from "./PreferenceNotificationModal/PreferenceNotificationModal";
import ExportExcelDataModal from "./ExportExcelDataModal/ExportExcelDataModal";

const ExcelButtons = ({
    skip,
    limit,
    city,
    company,
    subcompany,
    period,
    startDate,
    endDate,
    searchText,
    setReloadData,
    recall
}: ExcelButtonsPropTypes) => {
    const {t} = useTranslation();
    const stores = useStore();
    const [modalVisible, setModalVisible] = useState(false);
    const [notificationModalVisible, setNotificationModalVisible] = useState(false);
    const [openPreferencesCount, setOpenPreferencesCount] = useState(0);
    const [showPreferenceNotificationModal, setShowPreferenceNotificationModal] = useState(false);
    const [showExportExcelButtonModal, setShowExportExcelButtonModal] = useState(false);
    const [type, setType] = useState("vigo");

    const openPreferences = async () => {
        const openPreferences = await stores.shiftSuggestionStore.openPreferences({
            period,
            startDate,
            endDate
        });
        if (openPreferences) {
            setOpenPreferencesCount(openPreferences?.data.count);
        }
    };
    const resolvePreferences = async () => {
        const resolvePreferencesResponse = await stores.shiftSuggestionStore.resolvePreferences({
            period,
            startDate,
            endDate
        });
        if (resolvePreferencesResponse) {
            setShowPreferenceNotificationModal(false);
            openPreferences();
        }
    };

    useEffect(() => {
        openPreferences();
    }, [recall]);

    const closeUploadModal = (reloadData = false) => {
        if (reloadData) setReloadData();
        setModalVisible(false);
    };

    const exportExcelData = async () => {
        const data = {
            type,
            skip,
            limit,
            city,
            company,
            subcompany,
            period,
            startDate,
            endDate,
            searchText,
            addEmptyRows: true
        };
        const response = await stores.shiftSuggestionStore.downloadShiftExcelFileFromSuggestions(
            data
        );
        let link = document.createElement("a");
        link.href = response;
        link.download = `${t("screens.shiftSuggestion", {ns: "common"})}.xlsx`;
        document.body.appendChild(link);
        link.click();
        setTimeout(function() {
            window.URL.revokeObjectURL(link);
        }, 200);
    };
    return (
        <Row justify="end">
            <ShiftForecastUploadModal
                visibility={modalVisible}
                onCancel={closeUploadModal}
                setReloadData={setReloadData}
                setModalVisible={setModalVisible}
            />
            <SendNotification
                visibility={notificationModalVisible}
                date={moment().add(1, "d")}
                onCancel={() => setNotificationModalVisible(false)}
                setModalVisible={setNotificationModalVisible}
            />
            <PreferenceNotificationModal
                visibility={showPreferenceNotificationModal}
                onCancel={() => setShowPreferenceNotificationModal(false)}
                resolvePreferences={resolvePreferences}
                openPreferencesCount={openPreferencesCount}
            />
            <ExportExcelDataModal
                visibility={showExportExcelButtonModal}
                onCancel={() => setShowExportExcelButtonModal(false)}
                exportExcelData={exportExcelData}
                setType={setType}
            />

            <CustomButton
                type="primary"
                data-testid="exportWithExcelButton"
                onClick={() => setShowExportExcelButtonModal(true)}
                icon={<DownloadOutlined />}
            >
                {t("companyDetail.actions.exportWithExcel", {
                    ns: "companyDetail"
                })}
            </CustomButton>

            <CustomButton
                icon={<UploadOutlined />}
                data-testid="importFromExcelButton"
                onClick={() => setModalVisible(true)}
            >
                {t("companyDetail.actions.importFromExcel", {
                    ns: "companyDetail"
                })}
            </CustomButton>
            {openPreferencesCount > 0 && (
                <Badge count={openPreferencesCount}>
                    <CustomButton
                        onClick={() => setShowPreferenceNotificationModal(true)}
                        icon={<BellOutlined />}
                    />
                </Badge>
            )}
        </Row>
    );
};

export default ExcelButtons;
